import { AnyAction } from "redux";
import {
  Accelerator,
  acceleratorTypeToQuotaType,
} from "../../../types/Accelerator";
import { AcceleratorsQuotaStats } from "../../../types/AcceleratorQuotaStats";
import { AcceleratorQuotaStatsAction } from "../../actions/acceleratorQuotaStats";
import { AcceleratorQuotaStatsActionKey } from "../../actions/ActionKeys";
import { AppState } from "../../types";

export function acceleratorQuotaStats(
  state: AcceleratorsQuotaStats | null = null,
  action: AcceleratorQuotaStatsAction
): AcceleratorsQuotaStats | null {
  switch (action.type) {
    case AcceleratorQuotaStatsActionKey.SET_ACCELERATOR_QUOTA_STATS:
      return action.payload.stats;
    default:
      return state;
  }
}

const computeNewSecondsUsed = (
  state: AppState,
  intervalMillis: number,
  accelerator: Accelerator
) => {
  if (accelerator === "none") {
    return 0;
  }
  const sessions = state.local ? state.local.sessions : [];
  const acceleratorSessionCount = sessions.reduce(
    (total, session) =>
      total + (session && session.accelerator === accelerator ? 1 : 0),
    0
  );

  const seconds = intervalMillis / 1000;
  const secondsUsed = state.acceleratorQuotaStats![
    acceleratorTypeToQuotaType(accelerator)
  ]!.secondsUsed;

  return secondsUsed + acceleratorSessionCount * seconds;
};

export function acceleratorQuotaStatsGlobal(
  state: AppState,
  action: AnyAction | AcceleratorQuotaStatsAction
): AppState {
  if (
    action.type ===
    AcceleratorQuotaStatsActionKey.INCREMENT_ACCELERATOR_QUOTA_STATS
  ) {
    if (
      !state.acceleratorQuotaStats ||
      !state.acceleratorQuotaStats.gpu ||
      !state.acceleratorQuotaStats.tpu
    ) {
      return state;
    }

    const gpuNewSecondsUsed = computeNewSecondsUsed(
      state,
      action.payload.intervalMillis,
      "gpu"
    );

    const tpuNewSecondsUsed = computeNewSecondsUsed(
      state,
      action.payload.intervalMillis,
      state.notebook.accelerator
    );

    return {
      ...state,
      acceleratorQuotaStats: {
        ...state.acceleratorQuotaStats,
        gpu: {
          ...state.acceleratorQuotaStats.gpu,
          secondsUsed: gpuNewSecondsUsed,
        },
        tpu: {
          ...state.acceleratorQuotaStats.tpu,
          secondsUsed: tpuNewSecondsUsed,
        },
      },
    };
  }

  return state;
}
